const RECENTS_STORAGE_KEY = 'teetime.launcher.recents';
const DEFAULT_MAX_RECENTS = 4;
const hasWindow = () => typeof window !== 'undefined';
const readRecentKeys = () => {
    if (!hasWindow()) {
        return [];
    }
    try {
        const raw = window.localStorage.getItem(RECENTS_STORAGE_KEY);
        if (!raw) {
            return [];
        }
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) {
            return [];
        }
        return parsed.filter((value) => typeof value === 'string');
    }
    catch {
        return [];
    }
};
const writeRecentKeys = (keys) => {
    if (!hasWindow()) {
        return;
    }
    try {
        window.localStorage.setItem(RECENTS_STORAGE_KEY, JSON.stringify(keys));
    }
    catch {
        // Ignore JSON/quota/storage-access errors — recents are best-effort.
    }
};
/**
 * Record a launcher item key as most-recently-used. Most-recent-first,
 * deduped, and capped. Resilient to storage and serialization failures.
 */
export const recordRecentItem = (key, max = DEFAULT_MAX_RECENTS) => {
    if (!key) {
        return;
    }
    const existing = readRecentKeys().filter((candidate) => candidate !== key);
    writeRecentKeys([key, ...existing].slice(0, Math.max(0, max)));
};
/**
 * Resolve recent items from a pool of available items, preserving
 * most-recent-first order, deduping, and capping at `max`. Stale keys
 * (no longer in `items`) are dropped.
 */
export const getRecentItems = (items, max = DEFAULT_MAX_RECENTS) => {
    const byKey = new Map(items.map((item) => [item.key, item]));
    const seen = new Set();
    const resolved = [];
    for (const key of readRecentKeys()) {
        if (seen.has(key)) {
            continue;
        }
        const item = byKey.get(key);
        if (!item) {
            continue;
        }
        seen.add(key);
        resolved.push(item);
        if (resolved.length >= max) {
            break;
        }
    }
    return resolved;
};
export const APP_LAUNCHER_RECENTS_STORAGE_KEY = RECENTS_STORAGE_KEY;
//# sourceMappingURL=appLauncherRecents.js.map